import { baseAxios } from '@mc/axios-api';
import * as Api from './gen/api';
export * from './gen/configuration';
export * from './gen/model';
const baseURL = '';
// const baseAxios = axios;
// baseAxios.interceptors.response.use(null, standardErrorInterceptor);
const ZboApi = new Api.ZbocControllerApi(undefined, baseURL, baseAxios);
export { ZboApi, Api, };
//# sourceMappingURL=index.js.map